import { adminRepositories } from "data/admin/repositories";

export const dealsRepo = {
  list(params) {
    return adminRepositories.deals.list(params);
  },

  getById(id) {
    return adminRepositories.deals.getById(id);
  },

  create(deal) {
    return adminRepositories.deals.create(deal);
  },

  update(id, patch) {
    return adminRepositories.deals.update(id, patch);
  },

  remove(id) {
    return adminRepositories.deals.remove(id);
  },
  restore(id) {
    return adminRepositories.deals.restore(id);
  },
};
